import { CircularProgress, Stack, styled, Typography } from '@mui/material';
import React from 'react';
import { Variant } from '@mui/material/styles/createTypography';
import { StackProps } from '@mui/material/Stack/Stack';

export type LoaderProps = {
  message?: string;
  messageVariant?: Variant;
  messageColor?: string;
  testId?: string;
  isLoading?: boolean;
  spinnerSize?: string;
  spinnerColor?: string;
  stackHeight?: string;
  stackDirection?: 'row' | 'column';
} & StackProps;

export function Loader({
  message,
  messageVariant = 'h5',
  messageColor = 'primary',
  testId = 'loader',
  isLoading = true,
  spinnerSize = '50px',
  spinnerColor = 'primary',
  stackHeight = '100vh',
  stackDirection = 'column',
  ...props
}: LoaderProps): React.JSX.Element | null {
  if (!isLoading) return null;

  return (
    <Stack
      direction={stackDirection}
      data-testid={testId}
      display='flex'
      flex={1}
      height={stackHeight}
      justifyContent='center'
      alignItems='center'
      {...props}
    >
      <CircularProgress sx={{ color: spinnerColor }} size={spinnerSize} />
      {message && (
        <Message variant={messageVariant} color={messageColor}>
          {message}
        </Message>
      )}
    </Stack>
  );
}

export default Loader;

const Message = styled(Typography)(({ theme }) =>
  theme.unstable_sx({
    label: 'Message',
    color: theme.palette.primary.main,
    p: 2,
  })
);
